import { Component } from "@angular/core";
import { AuthService, UserService, CourseService } from "@bt/core";
import * as $ from 'jquery';
import { BaseComponent } from "@bt/core/base";
import { Router } from "@angular/router";
import { NotifierService } from "angular-notifier";

import {faUsers, faAddressCard, faLandmark, faWallet, faMoneyCheckAlt, faMoneyCheck, faSignInAlt} from '@fortawesome/free-solid-svg-icons';
import { environment } from "@src/environments/environment";

@Component({
	selector: "app-sidebar",
	templateUrl: "./sidebar.component.html",
	styleUrls: ["./sidebar.component.scss"]
})
export class SidebarComponent extends BaseComponent {
	faUsers = faUsers;
	faAddressCard=faAddressCard;
	faWallet = faWallet;
	faMoneyCheck = faMoneyCheck;
	pointsStr: string;
	learningLevel: string;
	faMoneyCheckAlt = faMoneyCheckAlt;
	faSignInAlt = faSignInAlt;
	faLandmark = faLandmark;

	protected logoFileName: string = environment.logoFileName;

	constructor
	(
		private authService: AuthService,
		private userService: UserService,
		private notifierService: NotifierService,
		private courseService: CourseService,
		private router:Router
	)
	{
		super();
		$(document).ready(function () {
			$('#sidebarCollapse').on('click', function () {
				if($('#sidebar').hasClass('active')){
					$(".profile-name").show();
					$(".profile-avatar").show();
					$(".profile-points").show();
				}
				else{
					setTimeout(function () {
						$(".profile-name").hide();
						$(".profile-avatar").hide();
						$(".profile-points").hide();
					}, 10);
				}

				$('#sidebar').toggleClass('active');
			});

			var $window = $(window);

			function checkWidth() {
				var windowsize = $(window).width();
				if (windowsize < 800 && !$('#sidebar').hasClass('active')) {
					$('#sidebar').addClass('active');
				}
			}
			checkWidth();
			$(window).resize(checkWidth);
		});

		var t = this;
		t.pointsStr = "0";
		t.learningLevel ="";
		t.setLoading(true);
		this.courseService.getUser()
			.then((resp) => {
				this.userService.currentUser = resp.data;
				t.setLoading(false);
			})
			.catch((error) => {
				console.error(error.error);
				t.setLoading(false);
				this.notifierService.notify('error', 'Пожалуйста выполните авторизацию');
				this.authService.logout();
			});
	}

	public logout():void {
		this.userService.logout();
	}

	public isSelectedPage(nameId:any):boolean{
		if(!nameId){
			return false;
		}
		var namePageList = location.pathname.split('/');
		var nameIdList = nameId.split('/');

		if (!!namePageList && namePageList.length > 0 &&
			!!nameIdList && nameIdList.length > 0) {
			for (let i = 0; i < nameIdList.length; i++) {

				if(namePageList.includes(nameId[i])){
					return true;
				}
				if (namePageList[i] != nameIdList[i]) {
					return false;
				}
			}
			return true;
		}
		return false;
	}

	public nextPage():void {
		if(this.userService.getRole() == 0)
		this.router.navigateByUrl('course-map');
		this.courseService.isNeedShowMap=false;
	}

	public getRole():number {
		return this.userService.getRole();
	}

	public currentUser():any {
		return this.userService.currentUser;
	}

	public isNeedShowMap():boolean {
		return this.courseService.isNeedShowMap;
	}

}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts